import { registerApi as api } from '../../api';

// export const uploadAttendanceRegisterOverride = async (fileData) => {
//   try {
//     const formData = new FormData();
//     formData.append('file', fileData);
//     const token = sessionStorage.getItem('token');
//     const selectedClientID = sessionStorage.getItem('selectedClient')
//     const response = await api.post('/upload_attendance_override', formData, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//       params : {
//         'selectedClientID' : selectedClientID
//       }
//     });
//     return response.data
//   } catch (error) {
//     throw error.response ? error.response.data.error : error.message;
//   }
// }



export const uploadAttendanceRegisterOverride = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_attendance_override', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params : {
        'selectedClientID' : selectedClientID
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};




export const fetchAttendanceRegisterOverride = async (current_month) => {
  const month = String(current_month || "").trim();
  if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(month) || month.includes("NaN")) {
    throw "A valid payroll month is required (YYYY-MM-DD).";
  }
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const response = await api.get(`/attendance_override_get/${month}`, {
      params: {
        client_id: client_ID
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const multiDeleteAttendanceRegisterOverride = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_attendance_override', ids, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log(response.data);
    return response.data
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}
